import styled from "@emotion/styled";

interface ConnectWalletTextProps {
  isVisible: boolean;
}

export const ConnectWalletText = styled.span<ConnectWalletTextProps>`
  display: ${props => (props.isVisible ? "inherit" : "none")};
  line-height: ${props => props.theme.lineHeights[2]};
`;
